export default class ImagesService {
  constructor(Api) {
    "ngInject"
    this.api = Api;

  }

  loadCategories(data) {
    return this.api.call({
      method: 'get',
      url: '/images/categories/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type
    })
  }

  saveCategory(data) {
    let
      url = '/images/saveCategory';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  removeCategory(id) {
    let
      url = `/images/removeCategory/${id}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  categoryById(id) {
    return this.api.call({
      method: 'get',
      url: '/images/category/' + id
    })
  }

  updateCategory(data) {
    let
      url = '/images/updateCategory';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  getImages(data) {
    return this.api.call({
      method: 'get',
      url: '/images/getAll/' + data.currentPage + '/' + data.pageLimit + '/' + data.field + '/' + data.order_type + '/' + data.image_category_id
    })
  }

  getImage(id) {
    return this.api.call({
      method: 'get',
      url: '/images/getById/' + id
    })
  }

  loadCategoriesNoLimit() {
    return this.api.call({
      method: 'get',
      url: '/images/categoriesNoLimit'
    })
  }

  removeImage(id) {
    let
      url = `/images/removeImage/${id}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  updateData(data) {
    let
      url = '/images/updateData';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  updateImageOrder(data) {
    let
      url = '/images/updateImageOrder'
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  updateImageData(data) {
    let
      url = '/images/updateImageData'
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  checkRecordExist(data) {
    let
      url = '/images/checkRecordExist'
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  saveImageData(data) {
    let
      url = '/images/saveImageData'
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/images/services/images.service.js
 **/